import { Filesystem, Directory } from '@capacitor/filesystem';
import { pdf } from '@react-pdf/renderer';

import { toast } from '../Toaster/Toast';

export async function savePdfToFilesystem({ document, fileName }: { document: React.ReactElement; fileName: string }) {
  // 1. Generate PDF Blob
  const blob = await pdf(document).toBlob();

  // 2. Convert Blob to full Data URL
  const base64DataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string); // includes data:application/pdf;base64,...
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

  // 3. Sanitize and prepare filename
  const baseName = fileName.replace(/\.pdf$/i, '');
  let finalName = baseName;
  let counter = 1;

  // 4. Check for existing files
  // TODO: Fix the infinite loop here, sometimes it doesn't break out of the loop
  // eslint-disable-next-line no-constant-condition
  while (true) {
    try {
      await Filesystem.readFile({
        path: `${finalName}.pdf`,
        directory: Directory.Documents,
      });
      // File exists, increment
      finalName = `${baseName} (${counter})`;
      counter++;
    } catch (error) {
      // File does not exist — good to use
      break;
    }
  }

  // 5. Save file
  Filesystem.writeFile({
    path: `${finalName}.pdf`,
    data: base64DataUrl,
    directory: Directory.Documents,
  })
    .then(() => {
      toast({
        variant: 'success',
        title: 'PDF saved successfully',
        description: `PDF "${finalName}" has been saved.`,
      });
    })
    .catch(() => {
      toast({
        variant: 'error',
        title: 'Failed to save PDF',
        description: `An error occurred while saving the PDF "${finalName}". Please try again.`,
      });
    });
}
